import React from 'react';
import PropTypes from 'prop-types';
import EventEmitter, { EVENT_TYPES } from '@lib/eventEmitter';
import Modal from '@components/application/modal';
import Money from '@components/application/money';
import DealBuilderButton from './dealBuilderButton';

const ReservePanel = ({ vehicle }) => {
  const openDealBuilderQuestionModal = () => {
    EventEmitter.emit(EVENT_TYPES.openModal, 'deal-builder-question');
  };

  const closeModal = () => EventEmitter.emit(EVENT_TYPES.closeModal);

  return (
    <div className="productheader__reserve ch-pv--3 ch-ph--2 js-off--hide">
      <p className="ch-fs--3 ch-mb--1">Interested in this car?</p>
      <p className="ch-mb--3 ch-mh--auto productheader__reserve--text ch-fw--500">
        Reserve it for 48 hours with a £99 refundable deposit
      </p>
      <button
        className="ch-btn ch-btn--cta ch-btn--block ch-mb--3"
        data-event-name="Product page: Reservation CTA"
        data-gtm-track="click_cta"
        data-gtm-track-label="Opened reservation"
        data-insight-event="conversion"
        onClick={openDealBuilderQuestionModal}
        type="button"
      >
        Reserve for £99
      </button>
      <div className="payment-methods">
        <span className="payment-logo payment-logo--gp">
          <span className="ch-reader">Google Pay</span>
        </span>
        <span className="payment-logo payment-logo--ap">
          <span className="ch-reader">Apple Pay</span>
        </span>
        <span className="payment-logo payment-logo--visa">
          <span className="ch-reader">Visa</span>
        </span>
        <span className="payment-logo payment-logo--mc">
          <span className="ch-reader">Mastercard</span>
        </span>
        <span className="payment-logo payment-logo--maestro">
          <span className="ch-reader">Maestro</span>
        </span>
      </div>
      <Modal hideClose id="deal-builder-question" setWindowHistory>
        <div className="ch-modal ch-modal--deal-builder-question">
          <div className="db-wrapper">
            <div className="db-header">
              <span className="db-brand">Reservation</span>
              <button
                className="ch-modal__close ch-modal__close--label ch-mt--1 sm:ch-mt--4"
                onClick={closeModal}
                type="button"
              >
                Exit
              </button>
            </div>
            <div className="db-body">
              <div className="db-modal__content">
                <div className="db-vehicle__wrapper">
                  {vehicle.photos[0] && (
                    <img
                      alt=""
                      className="ch-img--responsive"
                      src={vehicle.photos[0]}
                    />
                  )}
                  <div className="db-vehicle__content">
                    <span className="db-vehicle__title">
                      {vehicle.make} {vehicle.model}
                      <span className="db-vehicle__variant ch-text--ellipsis">
                        {vehicle.title.variant}
                      </span>
                    </span>
                    <span className="db-vehicle__price">
                      <Money amount={vehicle.pricing.cashPrice} />
                      {vehicle.pricing.cashPriceSuffix && (
                        <span className="ch-fs--3">
                          {' '}
                          {vehicle.pricing.cashPriceSuffix}
                        </span>
                      )}
                    </span>
                  </div>
                </div>
                <div className="ch-mt--4 ch-display--flex ch-text--bold">
                  <p>Reservation fee</p>
                  <span className="ch-ml--auto ch-text--bold">£99</span>
                </div>
                <ul className="ch-list ch-list--tick ch-mb--4">
                  <li>Reserve this car now for just £99</li>
                  <li>Deposit is fully refundable</li>
                </ul>
                <a
                  className="ch-btn ch-btn--cta ch-width--12"
                  href={`/reserve-now/new/${vehicle.stockReference}`}
                  rel="nofollow"
                >
                  Reserve now
                </a>
                {vehicle.isEligibleForDealBuilder && (
                  <>
                    <span className="ch-text-divider ch-mv--4">or</span>
                    <ul className="ch-list ch-list--tick ch-mb--4">
                      <li>Build your deal first, then reserve</li>
                      <li>Value your part exchange</li>
                      <li>Get a customised finance quote</li>
                      <li>Reserve for £99 when you&apos;re ready</li>
                    </ul>
                    <DealBuilderButton
                      stockReference={vehicle.stockReference}
                    />
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default ReservePanel;

ReservePanel.propTypes = {
  vehicle: PropTypes.object,
};
